import React from 'react';
import { Box } from 'native-base';

import { Divider } from '../Divider';
import type { IListProps } from './List.types';

const List: React.FunctionComponent<IListProps> = ({ children }) => {
  return (
    <Box>
      {React.Children.map(children, (child, index) => {
        if (index === 0) {
          return child;
        }

        return (
          <React.Fragment>
            <Divider />
            {child}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default List;
